const APPID = "JHA-4002";

export function getTraceId() {
  let str = sessionStorage.getItem(`${APPID}_traceId`);
  if (str) return str;
  str =
    Math.random()
      .toString()
      .substr(2, 36) + Date.now().toString(36);
  sessionStorage.setItem(`${APPID}_traceId`, str);
  return str;
}

function getAndroidBrand(model = "") {
  const m = model.toLowerCase();
  if (!m) return "";
  if (/^(sm-|gt-|sch-|sgh-|shv-)/.test(m)) return "Samsung";
  if (/^(mix|mi |mi-|mi\d|redmi|m\d{1,2}[a-z]|poco|2\d{3}[a-z0-9]{4,})/.test(m)) return "Xiaomi";
  if (/^(pixel)/.test(m)) return "Google";
  if (/^(huawei|huawe|ana-|bla-|ele-|lya-|noh-|tas-|vog-|aln-|bra-|clt-|dub-|eml-|frl-|hma-|ine-|jef-|jkm-|jny-|lio-|mar-|mrd-|nam-|oce-|pct-|pot-|sea-|snk-|stk-|tet-|wlz-|yal-)/.test(m)) return "HUAWEI";
  if (/^(honor|ali-|bkl-|yal-|nth-|peg-|any-|are-|bkk-|cdy-|cph-|dnn-|fne-|hry-|jsn-|lld-|mov-|rne-|rea-|tfy-|tnr-|crr-|ksa-)/.test(m)) return "HONOR";
  if (/^(vivo|v\d|pd\d)/.test(m)) return "vivo";
  if (/^(oppo|cph|peh|pht|pgc|pgd|pgf|a\d{3})/.test(m)) return "OPPO";
  if (/^(oneplus|hd19|kb20|le21|gm19|cph2\d|de2\d|ne2\d|in2\d|kb2\d|le2\d)/.test(m)) return "OnePlus";
  if (/^(realme|rmx)/.test(m)) return "realme";
  if (/^(moto|motorola|xt\d)/.test(m)) return "Motorola";
  if (/^(iqoo|i2\d|v\d{4}[a-z])/.test(m)) return "iQOO";
  if (/^(nokia|ta-\d+)/.test(m)) return "Nokia";
  if (/^(sony|xq-|g8\d|xperia)/.test(m)) return "Sony";
  if (/^(asus|zs\d|ai\d|rog)/.test(m)) return "ASUS";
  if (/^(meizu|m\d+ note)/.test(m)) return "Meizu";
  if (/^(nubia|nx\d)/.test(m)) return "nubia";
  if (/^(zte|zte-)/.test(m)) return "ZTE";
  if (/^(lenovo|tb-|l3\d)/.test(m)) return "Lenovo";
  return "";
}

function extractMobileModel(ua = "") {
  const sectionMatch = ua.match(
    /\(([^)]*(Android|HarmonyOS|OpenHarmony)[^)]*)\)/i
  );
  if (!sectionMatch || !sectionMatch[1]) return "";
  const candidates = sectionMatch[1]
    .split(";")
    .map(item => item.trim())
    .map(item => item.replace(/\s+Build\/.*$/i, "").trim())
    .filter(
      item =>
        item &&
        !/^linux$/i.test(item) &&
        !/^u$/i.test(item) &&
        !/^wv$/i.test(item) &&
        !/^android[\d.\s]*$/i.test(item) &&
        !/^[a-z]{2}([-_][a-z]{2})?$/i.test(item)
    );
  return candidates.length ? candidates[candidates.length - 1] : "";
}

function getBrandFromUA(model = "", ua = "") {
  const brand = getAndroidBrand(model);
  if (brand) return brand;
  if (/honor/i.test(ua)) return "HONOR";
  if (/(huawei|huaweibrowser)/i.test(ua)) return "HUAWEI";
  if (/\bxiaomi\b|miuibrowser/i.test(ua)) return "Xiaomi";
  if (/\boppo\b|oppobrowser|heytap/i.test(ua)) return "OPPO";
  if (/\bvivo\b|vivobrowser/i.test(ua)) return "vivo";
  if (/\bsamsungbrowser\b/i.test(ua)) return "Samsung";
  if (/\boneplus\b/i.test(ua)) return "OnePlus";
  if (/\brealme\b/i.test(ua)) return "realme";
  if (/\bmeizu\b/i.test(ua)) return "Meizu";
  if (/\blenovo\b/i.test(ua)) return "Lenovo";
  return "";
}

function parseDeviceInfo(ua = "") {
  if (!ua) return { device_brand: "", device_model: "" };
  if (/iPhone/i.test(ua)) return { device_brand: "Apple", device_model: "iPhone" };
  if (/iPad/i.test(ua)) return { device_brand: "Apple", device_model: "iPad" };
  if (/iPod/i.test(ua)) return { device_brand: "Apple", device_model: "iPod" };
  if (/Android/i.test(ua) || /(harmonyos|openharmony|hongmeng|hmos)/i.test(ua)) {
    const model = extractMobileModel(ua);
    return { device_brand: getBrandFromUA(model, ua), device_model: model };
  }
  if (/Macintosh|Mac OS X/i.test(ua)) return { device_brand: "Apple", device_model: "Mac" };
  if (/Windows/i.test(ua)) return { device_brand: "Microsoft", device_model: "Windows PC" };
  if (/Linux/i.test(ua)) return { device_brand: "Linux", device_model: "Linux PC" };
  return { device_brand: "", device_model: "" };
}

export function getSystemType(ua = navigator.userAgent || "") {
  if (
    /Android/i.test(ua) ||
    /(harmonyos|openharmony|hongmeng|hmos)/i.test(ua)
  ) {
    return "android";
  }
  if (/iPhone|iPad|iPod/i.test(ua)) {
    return "ios";
  }
  return "pc";
}

export function getSystemVersion(ua = navigator.userAgent || "") {
  const iosMatch = ua.match(/OS (\d+(?:[_\d]+)?)/i);
  if (iosMatch && iosMatch[1]) {
    return iosMatch[1].replace(/_/g, ".");
  }
  const androidMatch = ua.match(/Android\s+([\d.]+)/i);
  if (androidMatch && androidMatch[1]) {
    return androidMatch[1];
  }
  return "";
}

export function getDeviceType(ua = navigator.userAgent || "") {
  if (/iPhone/i.test(ua)) return "iPhone";
  if (/iPad/i.test(ua)) return "iPad";
  if (/iPod/i.test(ua)) return "iPod";
  if (
    /Android/i.test(ua) ||
    /(harmonyos|openharmony|hongmeng|hmos)/i.test(ua)
  ) {
    return extractMobileModel(ua);
  }
  const { device_model } = parseDeviceInfo(ua);
  return device_model;
}

// SDK 对 int 字段做严格校验，小数会导致整条事件被丢弃
function toInt(value) {
  const n = Number(value);
  return isFinite(n) ? Math.round(n) : 0;
}

function callTracker(method, data) {
  const tracker = window.tracker;
  if (!tracker || typeof tracker[method] !== "function") {
    return Promise.resolve({ sent: false, reason: "tracker_unavailable" });
  }
  return tracker[method](data);
}

/**
 * 上报落地页展示
 * vm: 组件 this，必须传（读取 vm.version）
 * opts: { landing_page_id }
 */
export function landingPageView(vm, opts = {}) {
  return callTracker("landingPageView", {
    landing_page_id: opts.landing_page_id || `${APPID}_${vm.version}`
  });
}

/**
 * 上报落地页点击
 * vm: 组件 this
 * opts: { landing_page_id, tab_key, tab_name, click_coordinates_x, click_coordinates_y,
 *         click_x_percent, click_y_percent, screen_width, screen_height, trace_id }
 */
export function landingPageClick(vm, opts = {}) {
  const screenW = window.screen ? window.screen.width : opts.screen_width || 0;
  const screenH = window.screen
    ? window.screen.height
    : opts.screen_height || 0;
  const x = opts.click_coordinates_x || 0;
  const y = opts.click_coordinates_y || 0;
  return callTracker("landingPageClick", {
    landing_page_id: opts.landing_page_id || `${APPID}_${vm.version}`,
    tab_key: opts.tab_key || "",
    tab_name: opts.tab_name || "",
    click_coordinates_x: toInt(x),
    click_coordinates_y: toInt(y),
    click_x_percent: toInt(
      typeof opts.click_x_percent === "number"
        ? opts.click_x_percent
        : (x / (screenW || 1)) * 100
    ),
    click_y_percent: toInt(
      typeof opts.click_y_percent === "number"
        ? opts.click_y_percent
        : (y / (screenH || 1)) * 100
    ),
    screen_width: toInt(screenW),
    screen_height: toInt(screenH),
    trace_id: opts.trace_id || getTraceId()
  });
}
